"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delayRunInAction = delayRunInAction;
exports.generateUniqueViewId = void 0;
exports.makeSubclassObservable = makeSubclassObservable;

var mobx = _interopRequireWildcard(require("mobx"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

let UNIQUE_VIEW_ID = 0;

const generateUniqueViewId = () => UNIQUE_VIEW_ID++;

exports.generateUniqueViewId = generateUniqueViewId;
const objectPrototype = Object.prototype;

function makeSubclassObservable(target, overrides, options) {
  if (mobx.isObservable(target)) {
    throw new Error('Target has already been observed');
  }

  const annotations = {};
  let current = target;

  while (current && current !== objectPrototype) {
    Reflect.ownKeys(current).forEach(key => {
      if (key === mobx.$mobx || key === 'constructor') {
        return;
      } else if (annotations[key]) {
        throw new Error(`Invalid use of '${String(key)}', subclasses can not override parent methods/properties`);
      }

      annotations[key] = overrides && key in overrides ? overrides[key] : true;
    });
    current = Object.getPrototypeOf(current);
  }

  return mobx.makeObservable(target, annotations, options);
}

function delayRunInAction(delay, actionBlock) {
  let timer = setTimeout(() => {
    timer = null;
    mobx.runInAction(() => actionBlock());
  }, delay);
  return () => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };
}